import { Filter } from '~modules/media-library/model/Filter';
import { FilterOption } from '~modules/media-library/model/FilterOption';
import { isCheckFilter } from '~modules/media-library/model/FilterValidator';
import { flattenArrayWithChildren } from '~utils/array';

const OPTION_ID_DIVIDER = '~~~';

export function getFilterFromListById(list: Filter[], id: Filter['id']) {
  return list.find(item => item.id === id);
}

function getFilterOptionFromFilterById(filter: Filter, id: string) {
  if (isCheckFilter(filter)) {
    return findFilterOptionById(filter.options, id);
  }
}

export function getFilterOptionFromListById(list: Filter[], id: FilterOption['id']): FilterOption {
  const [filterId, optionKey] = splitFilterOptionId(id);
  if (!filterId || !optionKey) return;
  const filter = getFilterFromListById(list, filterId);
  if (!filter) return;

  const filterOption = getFilterOptionFromFilterById(filter, id);
  return filterOption;
}

export function splitFilterOptionId(id: FilterOption['id']) {
  return id.split(OPTION_ID_DIVIDER, 2) as [Filter['id'], string?];
}

export function makeFilterOptionId(filterId: Filter['id'], optionId: unknown) {
  const filterOptionId = `${filterId}${OPTION_ID_DIVIDER}${optionId}`;
  return filterOptionId;
}

export function isFilterOptionOfFilter(filterId: Filter['id'], optionId: FilterOption['id']) {
  return optionId.startsWith(`${filterId}${OPTION_ID_DIVIDER}`);
}

export function findFilterOptionById(items: FilterOption[], id: FilterOption['id']) {
  return flattenArrayWithChildren(items).find(item => item.id === id);
}

export function findSelectChildFilterOptionIds(selectedIds: Array<FilterOption['id']>, item: FilterOption) {
  let ids: string[] = [];
  if (item.children && item.children.length > 0) {
    Object.values(item.children).forEach(child => {
      if (selectedIds.includes(child.id)) ids.push(child.id);
      ids = [...ids, ...findSelectChildFilterOptionIds(selectedIds, child)];
    });
  }
  return ids;
}

export function findInvolvedFilterGroupIds(selectedIds: Array<FilterOption['id']>, list: FilterOption[]) {
  let ids: string[] = [];
  for (const item of list) {
    const involvedFilterOptionGroupIds = findInvolvedFilterOptionGroupIds(selectedIds, item);
    if (involvedFilterOptionGroupIds.length > 0) ids = [...ids, ...involvedFilterOptionGroupIds];
  }
  return ids;
}

export function findInvolvedFilterOptionGroupIds(selectedIds: Array<FilterOption['id']>, item: FilterOption) {
  let ids: string[] = [];

  // check if is group
  if (item.children && item.children.length > 0) {
    if (hasSelectFilterOptions(selectedIds, item)) ids.push(item.id);

    Object.values(item.children).forEach(child => {
      ids = [...ids, ...findInvolvedFilterOptionGroupIds(selectedIds, child)];
    });
  }
  return ids;
}

export function hasSelectFilterOptions(selectedIds: Array<FilterOption['id']>, item: FilterOption) {
  if (selectedIds.includes(item.id)) {
    return true;
  } else {
    if (item.children && item.children.length > 0) {
      return Object.values(item.children).find(child => {
        return hasSelectFilterOptions(selectedIds, child);
      });
    }
  }
}
